import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import {
  GetAllInvestigationTypesUseCase,
  GetInvestigationTypesStateUseCase
} from '@features/investigation-types';

export const getInvestigationTypesResolver: ResolveFn<void> = () => {
  const _getAllInvestigationTypesUseCase = inject(GetAllInvestigationTypesUseCase);
  const _getInvestigationTypesStateUseCase = inject(GetInvestigationTypesStateUseCase);

  const state = _getInvestigationTypesStateUseCase.execute();
  if (!state.hasInvestigationTypes()) {
    _getAllInvestigationTypesUseCase.execute().subscribe();
  }
};
